<template>
    <ul class="pagination pagination-sm m-0 float-right">
        <li :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click="prevPage">Предыдущая</a> 
        </li>
            <li class="disabled">
                <span class="page-link text-dark text-center" href="#">Стр {{ currentPage }} из {{ totalPage }}</span>
                <span class="page-link text-dark">Перейти на <input style="width:25px;border:1px solid #dee2e6;text-align: center;" type="text" v-model="currentPage" @change="gotoPage(currentPage)" /></span>
            </li>
        <li :class="{ disabled: currentPage === totalPage }" class="page-item">
            <a class="page-link" href="#" @click="nextPage">Следующая</a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
      currentPage: Number,
      totalPage: Number,
    },
    data() {
        return {
            pagination: {
                current_page: 1,
                last_page: null,
                next_page_url: null,
                prev_page_url: null,
            }
        }
    },
    methods: {
        prevPage() {
            if (this.currentPage > 1) {
                this.$parent.$emit('page-changed', this.currentPage - 1);
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPage) {
                this.$parent.$emit('page-changed', this.currentPage + 1);
            }
        },
        gotoPage(page) {
            if (page >= 1 && page <= this.totalPage) {
                this.$parent.$emit('page-changed', page);
            }
        },
    }
}
</script>